import { render, staticRenderFns } from "./MarketingExport.vue?vue&type=template&id=1d06a4d7&"
import script from "./MarketingExport.vue?vue&type=script&lang=ts&"
export * from "./MarketingExport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports